webpackJsonp([37],{

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_KanbanAdjustDayoffUpload_js__ = __webpack_require__(1303);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07914c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjustDayoffUpload_vue__ = __webpack_require__(1502);
function injectStyle (ssrContext) {
  __webpack_require__(1500)
}
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07914c58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_KanbanAdjustDayoffUpload_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07914c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KanbanAdjustDayoffUpload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  // upload kba
  uploadKba: function uploadKba(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjustupload/uploadkba', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  uploadKbaFactor: function uploadKbaFactor(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjustupload/uploadkbafactor', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },

  // set cycle
  getKbaTempList: function getKbaTempList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjustupload/kbatemplist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getCycleList: function getCycleList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjustupload/cyclelist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getKbaCycleList: function getKbaCycleList(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'kanbanadjustupload/kbacyclelist', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  setKbaCycleList: function setKbaCycleList(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjustupload/setkbacyclelist', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createKba: function createKba(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjustupload/createkba', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  createKbaFactor: function createKbaFactor(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'kanbanadjustupload/createkbafactor', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'KanbanAdjustDayoffUpload',
  components: {},
  data: function data() {
    return {
      // upload kba
      is_load: true,
      is_upload_error: true,
      kba_temp: [],
      kba_temp_status: {
        all: 0,
        success: 0,
        error: 0
      },
      // set cycle
      spl_id: 0,
      spl_list: [],
      dk_id: 0,
      dock_list: [],
      spl_plant_code: '',
      date_1: null,
      cdcl_1: 0,
      date_2: null,
      cdcl_2: 0,
      date_3: null,
      cdcl_3: 0,
      cycle_list_2: [],
      cycle_list_3: [],
      cycle_list_kba: [],
      // modal
      kbalt_modal: false,
      kbalt_data: []
    };
  },
  created: function created() {
    this.checkOAuth();
    this.getKbaTempList();
  },
  mounted: function mounted() {
    var _this = this;

    $('#select2-dock').select2({
      placeholder: '- Select Dock -',
      allowClear: true,
      dropdownPosition: 'below'
    });
    $('#select2-dock').on('select2:select', function (e) {
      _this.changeDock($('#select2-dock').val());
    });
    $('#select2-dock').on('select2:clear', function (e) {
      _this.changeDock('0');
    });
    $('#select2-supplier').select2({
      placeholder: '- Select Supplier -',
      allowClear: true,
      dropdownPosition: 'below'
    });
    $('#select2-supplier').on('select2:select', function (e) {
      _this.changeSupplier($('#select2-supplier').val());
    });
    $('#select2-supplier').on('select2:clear', function (e) {
      _this.changeSupplier('0');
    });
  },

  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: 'KanbanAdjust',
        params: {
          active_page: typeof this.$route.params.active_page !== 'undefined' ? this.$route.params.active_page : 1,
          dock: typeof this.$route.params.dock !== 'undefined' ? this.$route.params.dock : '',
          supplier: typeof this.$route.params.supplier !== 'undefined' ? this.$route.params.supplier : '',
          part: typeof this.$route.params.part !== 'undefined' ? this.$route.params.part : '',
          is_active: typeof this.$route.params.is_active !== 'undefined' ? this.$route.params.is_active : ''
        }
      });
    },

    // upload kba
    uploadKba: function uploadKba() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Confirm Upload Adjust',
        text: 'Old adjust data will be deleted.',
        //  icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Upload now!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          _this2.is_load = true;
          _this2.kba_temp = [];
          var form_data = new FormData();
          var kba_file = document.querySelector('#kba_file');
          form_data.append('kba_file', kba_file.files[0]);
          _this2.is_load = true;
          __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].uploadKba(_this2.$store.state.URLHost, form_data, _this2.header, function (result) {
            _this2.is_load = false;
            _this2.getKbaTempList();
            _this2.$refs.kba_file.value = null;
            if (result.is_error === 0) {
              _this2.alertUploadKba('success', result.message);
            } else {
              var message = '';
              var spl_message = result.message.split('|');
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(spl_message), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var item = _step.value;

                  message = message + '- ' + item + '<br>';
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              _this2.alertUploadKba('error', message);
            }
          }, function (error) {
            _this2.is_load = false;
            _this2.getKbaTempList();
            _this2.$refs.kba_file.value = null;
            _this2.alertUploadKba('error', error.message);
          });
        }
      });
    },
    alertUploadKba: function alertUploadKba(type, message) {
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: '<h3 class="card-title">Result Upload Adjust</h3>',
        html: '<p class="text-left">' + message + '</p>',
        showCloseButton: false,
        showCancelButton: false,
        confirmButtonText: 'OK, Close this window.'
      });
    },

    // set cycle
    getKbaTempList: function getKbaTempList() {
      var _this3 = this;

      this.is_load = true;
      this.dock_list = [];
      this.spl_list = [];
      this.kba_temp = [];
      this.kba_temp_status.all = 0;
      this.kba_temp_status.success = 0;
      this.kba_temp_status.error = 0;
      this.date_1 = null;
      this.cdcl_1 = 0;
      this.date_2 = null;
      this.cdcl_2 = 0;
      this.date_3 = null;
      this.cdcl_3 = 0;
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        spl_plant_code: this.spl_plant_code
      };
      __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].getKbaTempList(this.$store.state.URLHost, this.header, function (result) {
        _this3.is_load = false;
        if (result.response === true) {
          if (result.is_error === 0) {
            _this3.kba_temp = result.data.kba_temp;
            _this3.date_1 = __WEBPACK_IMPORTED_MODULE_3_moment___default()(result.data.date_1).startOf('day');
            _this3.cdcl_1 = result.data.cdcl_1;
            _this3.dock_list = result.data.dock_list;
            _this3.spl_list = result.data.spl_list;
          }
          _this3.kba_temp_status.all = result.data.kba_temp_status.all;
          _this3.kba_temp_status.success = result.data.kba_temp_status.success;
          _this3.kba_temp_status.error = result.data.kba_temp_status.error;
        } else {
          // this.alert_msg('warning', 'An error occurred.', result.message)
        }
      }, function (error) {
        _this3.is_load = false;
        _this3.alert_msg('error', 'An error occurred.', error.message);
      });
    },
    changeDock: function changeDock(id) {
      this.dk_id = id;
      this.clearFilter();
    },
    changeSupplier: function changeSupplier(id) {
      this.spl_id = id;
      this.clearFilter();
    },
    changePlantCode: function changePlantCode() {
      this.clearFilter();
    },
    clearFilter: function clearFilter() {
      this.date_1 = null;
      this.cdcl_1 = 0;
    },
    setDate2: function setDate2(date, date_string) {
      var _this4 = this;

      this.is_load = true;
      this.date_2 = date ? date.startOf('day') : null;
      this.date_3 = null;
      this.cdcl_2 = 0;
      this.cdcl_3 = 0;
      this.cycle_list_2 = [];
      this.cycle_list_3 = [];
      this.cycle_list_kba = [];
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_2).format('YYYY-MM-DD')
      };
      __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].getCycleList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this4.cycle_list_2 = result.data.cycle_list;
        }
        _this4.is_load = false;
      }, function (error) {
        _this4.is_load = false;
        console.log(error.message);
      });
    },
    setDate3: function setDate3(date, date_string) {
      var _this5 = this;

      this.is_load = true;
      this.date_3 = date ? date.startOf('day') : null;
      this.cdcl_3 = 0;
      this.cycle_list_3 = [];
      this.cycle_list_kba = [];
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_3).format('YYYY-MM-DD')
      };
      __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].getCycleList(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this5.cycle_list_3 = result.data.cycle_list;
        }
        _this5.is_load = false;
      }, function (error) {
        _this5.is_load = false;
        console.log(error.message);
      });
    },
    setCycle2: function setCycle2() {
      this.date_3 = null;
      this.cdcl_3 = 0;
      this.cycle_list_3 = [];
      this.cycle_list_kba = [];
    },
    setCycle3: function setCycle3() {},
    disabledInputKbaCycleList: function disabledInputKbaCycleList() {
      if (this.date_1 === null || this.cdcl_1 === 0) {
        return true;
      }
      return false;
    },
    disabledDate2: function disabledDate2(current) {
      return current && this.date_1 && current < this.date_1;
    },
    disabledDate3: function disabledDate3(current) {
      return current && this.date_2 && current < this.date_2;
    },
    disabledCycle2: function disabledCycle2(cdcl_2) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_1).isSame(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_2))) {
        if (this.cdcl_1 >= cdcl_2) {
          return true;
        }
        return false;
      }
      return false;
    },
    disabledCycle3: function disabledCycle3(cdcl_3) {
      if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_2).isSame(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_3))) {
        if (this.cdcl_2 > cdcl_3) {
          return true;
        }
        return false;
      }
      return false;
    },
    getKbaCycleList: function getKbaCycleList() {
      var _this6 = this;

      this.is_load = true;
      this.cycle_list_kba = [];
      this.header.params = {
        spl_id: this.spl_id,
        dk_id: this.dk_id,
        date_1: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_1).format('YYYY-MM-DD'),
        date_2: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_2).format('YYYY-MM-DD'),
        date_3: __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.date_3).format('YYYY-MM-DD'),
        cdcl_1: this.cdcl_1,
        cdcl_2: this.cdcl_2,
        cdcl_3: this.cdcl_3
      };
      __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].getKbaCycleList(this.$store.state.URLHost, this.header, function (result) {
        _this6.is_load = false;
        if (result.response === true) {
          _this6.cycle_list_kba = result.data.cycle_list_kba;
        } else {
          _this6.cycle_list_kba = [];
        }
      }, function (error) {
        _this6.is_load = false;
        console.log(error.message);
      });
    },
    setKbaCycleList: function setKbaCycleList() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Confirm Set Adjust Cycle',
        text: 'You want to set adjust cycle list?',
        //  icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Set now!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          _this7.is_load = true;
          var form_data = {
            spl_id: _this7.spl_id,
            dk_id: _this7.dk_id,
            spl_plant_code: _this7.spl_plant_code,
            cycle_list_kba: _this7.cycle_list_kba
          };
          __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].setKbaCycleList(_this7.$store.state.URLHost, form_data, _this7.header, function (result) {
            _this7.is_load = false;
            _this7.cycle_list_kba = [];
            if (result.response === true) {
              _this7.alert_msg('success', 'Successful.', result.message);
            } else {
              _this7.alert_msg('danger', 'An error occurred.', result.message);
            }
            _this7.getKbaTempList();
          }, function (error) {
            _this7.is_load = false;
            _this7.alert_msg('danger', 'An error occurred.', error.message);
          });
        }
      });
    },
    openKbaltModal: function openKbaltModal(kbat_id) {
      this.kbalt_modal = true;
      var index = this.kba_temp.findIndex(function (item) {
        return item.kbat_id === kbat_id;
      });
      this.kbalt_data = this.kba_temp[index].list;
      setTimeout(function () {
        $('#kbalt_modal').modal('show');
      }, 200);
    },
    closeKbaltModal: function closeKbaltModal() {
      var _this8 = this;

      $('#kbalt_modal').modal('hide');
      setTimeout(function () {
        _this8.kbalt_data = [];
        _this8.kbalt_modal = false;
      }, 200);
    },

    // create kba
    createKba: function createKba() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
        title: 'Confirm Create Adjust',
        text: 'You want to create kanban adjust dayoff ?',
        // icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, Create now!',
        cancelButtonText: 'Cancel'
      }).then(function (result) {
        if (result.value) {
          _this9.is_load = true;
          var form_data = {
            spl_id: _this9.spl_id,
            dk_id: _this9.dk_id,
            spl_plant_code: _this9.spl_plant_code
          };
          __WEBPACK_IMPORTED_MODULE_1__models_KanbanAdjustUpload__["a" /* default */].createKba(_this9.$store.state.URLHost, form_data, _this9.header, function (response) {
            _this9.is_load = false;
            _this9.getKbaTempList();
            _this9.alert_msg('success', 'Successful.', response.message);
          }, function (error) {
            _this9.is_load = false;
            _this9.alert_msg('danger', 'An error occurred.', error.message);
          });
        }
      });
    },
    getExample: function getExample() {
      var _this10 = this;

      setTimeout(function () {
        _this10.$refs.export_form.submit();
      }, 500);
    },
    momentTH: function momentTH(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('DD/MM/YYYY');
    }
  }
});

/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("dd534342", content, true, {});

/***/ }),

/***/ 1501:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, "#kba_temp_table[data-v-07914c58]{font-size:80%!important}#kba_temp_table td[data-v-07914c58],#kba_temp_table th[data-v-07914c58]{padding:10px!important}#cycle_list_kba_table[data-v-07914c58]{font-size:80%!important}#cycle_list_kba_table td[data-v-07914c58],#cycle_list_kba_table th[data-v-07914c58]{padding:10px!important}select option[data-v-07914c58]:disabled{background-color:#e9ecef}.cursor_default[data-v-07914c58]{cursor:default!important}", "", {"version":3,"sources":["/vercel/path0/ui/src/views/KanbanAdjustDayoffUpload.vue"],"names":[],"mappings":"AACA,iCACE,uBAA0B,CAC3B,AAID,wEACE,sBAAyB,CAC1B,AACD,uCACE,uBAA0B,CAC3B,AAID,oFACE,sBAAyB,CAC1B,AACD,wCACE,wBAA0B,CAC3B,AACD,iCACE,wBAA2B,CAC5B","file":"KanbanAdjustDayoffUpload.vue","sourcesContent":["\n#kba_temp_table[data-v-07914c58] {\n  font-size: 80% !important;\n}\n#kba_temp_table th[data-v-07914c58] {\n  padding: 10px !important;\n}\n#kba_temp_table td[data-v-07914c58] {\n  padding: 10px !important;\n}\n#cycle_list_kba_table[data-v-07914c58] {\n  font-size: 80% !important;\n}\n#cycle_list_kba_table th[data-v-07914c58] {\n  padding: 10px !important;\n}\n#cycle_list_kba_table td[data-v-07914c58] {\n  padding: 10px !important;\n}\nselect option[data-v-07914c58]:disabled {\n  background-color: #e9ecef;\n}\n.cursor_default[data-v-07914c58] {\n  cursor: default !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-md-flex pb-2"},[_c('div',[_c('h3',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.$route.meta.title_sub !== '' ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})]),_vm._v(" "),_c('div',{staticClass:"ms-auto"},[_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fas fa-arrow-left mr-1"}),_vm._v(" Back")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-sm-8 col-xs-12"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-4 col-sm-4 col-xs-12 d-grid gap-2"},[_c('input',{ref:"kba_file",staticClass:"form-control",attrs:{"type":"file","name":"kba_file","id":"kba_file","accept":".xlsx"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12"},[_c('input',{staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.kba_temp_status.success + ' / ' + _vm.kba_temp_status.all}})]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 d-grid gap-2"},[_c('button',{staticClass:"btn btn-info btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":_vm.uploadKba}},[_c('i',{staticClass:"fa fa-upload mr-1"}),_vm._v("\n              Upload\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 d-grid gap-2"},[_c('button',{staticClass:"btn btn-success btn-sm btn-sm-fix",attrs:{"type":"button","disabled":!(_vm.kba_temp_status.all !== 0 && _vm.kba_temp_status.success === _vm.kba_temp_status.all)},on:{"click":_vm.createKba}},[_c('i',{staticClass:"fa fa-check mr-1"}),_vm._v("\n              Create\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-2 col-xs-12 d-grid gap-2"},[_c('button',{staticClass:"btn btn-primary btn-sm btn-sm-fix",attrs:{"type":"button"},on:{"click":function($event){return _vm.getExample()}}},[_c('i',{staticClass:"fa fa-file mr-1"}),_vm._v("\n              Example\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"table-responsive tableFixHead"},[_c('table',{staticClass:"table customize-table mb-0 v-middle",attrs:{"id":"kba_temp_table"}},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.is_load === true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),(_vm.kba_temp.length === 0 && _vm.is_load === false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"20"}},[_vm._v("No Data")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.kba_temp),function(item,index){return _c('tr',{key:'item_' + index,on:{"click":function($event){return _vm.openKbaltModal(item.kbat_id)}}},[_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.ordering_date))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.ordering_time))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.dk_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.spl_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.spl_plant_code))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.spl_name))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.pr_id_number))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.pr_number))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.pr_name))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(item.qty_pack))]),_vm._v(" "),_c('td',{staticClass:"align-top text-right"},[_vm._v(_vm._s(item.qty_order))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.trip))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.delivery_date))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[_vm._v(_vm._s(item.delivery_time))]),_vm._v(" "),_c('td',{staticClass:"align-top"},[(item.list.length > 1)?_c('span',{staticClass:"badge bg-success cursor_default"},[_vm._v("complete")]):_c('span',{staticClass:"badge bg-danger cursor_default"},[_vm._v("incomplete")])])])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 col-sm-4 col-xs-12"},[_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Dock")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dk_id),expression:"dk_id"}],staticClass:"form-select form-select-sm w-100",attrs:{"name":"active","id":"select2-dock"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.dk_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Select Dock -")]),_vm._v(" "),_vm._l((_vm.dock_list),function(item,index){return _c('option',{key:'dk_' + index,domProps:{"value":item.id}},[_vm._v(_vm._s(item.code + ' (' + item.name + ')'))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Supplier Code")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_id),expression:"spl_id"}],staticClass:"form-select form-select-sm w-100",attrs:{"name":"active","id":"select2-supplier"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.spl_id=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Select Supplier -")]),_vm._v(" "),_vm._l((_vm.spl_list),function(item,index){return _c('option',{key:'spl_' + index,domProps:{"value":item.id}},[_vm._v(_vm._s(item.code + ' (' + item.name + ')'))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Supplier Plant Code")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.spl_plant_code),expression:"spl_plant_code"}],staticClass:"form-control form-control-sm w-100",attrs:{"type":"text"},domProps:{"value":(_vm.spl_plant_code)},on:{"change":function($event){return _vm.clearFilter()},"input":function($event){if($event.target.composing){ return; }_vm.spl_plant_code=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix w-100",attrs:{"type":"button","disabled":!(_vm.dk_id !== 0 && _vm.spl_id !== 0 && _vm.spl_plant_code !== '')},on:{"click":_vm.getKbaTempList}},[_c('i',{staticClass:"fa fa-refresh mr-1"}),_vm._v("\n              Search\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Start Date")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('a-date-picker',{staticClass:"datepicker-modal w-100",attrs:{"format":'DD/MM/YYYY',"value":_vm.date_2,"disabled-date":_vm.disabledDate2,"disabled":_vm.disabledInputKbaCycleList(),"placeholder":"Start Date","required":""},on:{"change":_vm.setDate2}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please enter value.")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Start Cycle")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdcl_2),expression:"cdcl_2"}],staticClass:"form-select",attrs:{"disabled":_vm.disabledInputKbaCycleList()},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdcl_2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setCycle2]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- Start Cycle -")]),_vm._v(" "),_vm._l((_vm.cycle_list_2),function(item,i){return _c('option',{key:'cl' + i,attrs:{"disabled":_vm.disabledCycle2(i + 1)},domProps:{"value":i + 1}},[_vm._v("\n                  "+_vm._s(item.cdp_name + ' ' + item.cdcl_truck_no + ' ( ' + item.cdcl_time_h + ':' + item.cdcl_time_m + ' )')+"\n                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("End Date")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('a-date-picker',{staticClass:"datepicker-modal w-100",attrs:{"format":'DD/MM/YYYY',"value":_vm.date_3,"disabled-date":_vm.disabledDate3,"disabled":_vm.disabledInputKbaCycleList(),"placeholder":"End Date","required":""},on:{"change":_vm.setDate3}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please enter value.")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("End Cycle")]),_vm._v(" "),_c('div',{staticClass:"mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdcl_3),expression:"cdcl_3"}],staticClass:"form-select",attrs:{"disabled":_vm.disabledInputKbaCycleList()},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdcl_3=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.setCycle3]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("- End Cycle -")]),_vm._v(" "),_vm._l((_vm.cycle_list_3),function(item,i){return _c('option',{key:'cl' + i,attrs:{"disabled":_vm.disabledCycle3(i + 1)},domProps:{"value":i + 1}},[_vm._v("\n                  "+_vm._s(item.cdp_name + ' ' + item.cdcl_truck_no + ' ( ' + item.cdcl_time_h + ':' + item.cdcl_time_m + ' )')+"\n                ")])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-6"},[_c('label'),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-sm btn-sm-fix w-100",attrs:{"type":"button","disabled":!(_vm.dk_id !== 0 && _vm.spl_id !== 0 && _vm.date_1 !== null && _vm.date_2 !== null && _vm.date_3 !== null && _vm.cdcl_1 !== 0 && _vm.cdcl_2 !== 0 && _vm.cdcl_3 !== 0)},on:{"click":_vm.getKbaCycleList}},[_c('i',{staticClass:"fa fa-refresh mr-1"}),_vm._v("\n              Get Adjust Cycle\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label'),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-sm btn-sm-fix w-100",attrs:{"type":"button","disabled":!(_vm.dk_id !== 0 && _vm.spl_id !== 0 && _vm.spl_plant_code !== '' && _vm.cycle_list_kba.length > 0)},on:{"click":_vm.setKbaCycleList}},[_c('i',{staticClass:"fa fa-refresh mr-1"}),_vm._v("\n              Set Adjust Cycle\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"row mb-3"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm customize-table mb-0 v-middle",attrs:{"id":"cycle_list_kba_table"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.is_load === true)?_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),(_vm.cycle_list_kba.length < 1 && _vm.is_load === false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("No Data.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.cycle_list_kba),function(item,i){return _c('tr',{key:'tr_' + i},[_c('td',{},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdp_name))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdcl_truck_no))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(_vm.momentTH(item.cdt_date)))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdcl_time_h + ':' + item.cdcl_time_m))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdcl_category))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s('T' + item.step_adjust))])])})],2)])])])])])])]),_vm._v(" "),(_vm.kbalt_modal)?_c('div',{staticClass:"modal fade",attrs:{"id":"kbalt_modal","data-bs-backdrop":"static","data-bs-keyboard":"false"}},[_c('div',{staticClass:"modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Adjust Cycle List")]),_vm._v(" "),_c('button',{staticClass:"btn-close btn_close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeKbaltModal()}}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm customize-table mb-0 v-middle",attrs:{"id":"cycle_list_kba_table"}},[_vm._m(2),_vm._v(" "),_c('tbody',[(_vm.kbalt_data.length < 1 && _vm.is_load === false)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"7"}},[_vm._v("No Data.")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.kbalt_data),function(item,i){return _c('tr',{key:'tr_modal_' + i},[_c('td',{},[_vm._v(_vm._s(i + 1))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdp_name))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdcl_truck_no))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(_vm.momentTH(item.kbalt_date)))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.kbalt_time_h + ':' + item.kbalt_time_m))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s(item.cdcl_category))]),_vm._v(" "),_c('td',{},[_vm._v(_vm._s('T' + item.kbalt_type_adjust))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(item.kbalt_per_truck))])])})],2)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary btn-fix btn_close",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeKbaltModal()}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])])])])]):_vm._e(),_vm._v(" "),_c('form',{ref:"export_form",attrs:{"action":_vm.$store.state.URLBase + '/static/excel/example_adjust_data.php',"method":"post","target":"_blank"}},[_c('input',{attrs:{"type":"hidden","name":"type","value":"dayoff"}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{staticClass:"border-bottom border-top"},[_vm._v("O Date")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("O Time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Dock")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("S Code")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("S Plant")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("S Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("P ID")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("P No")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("P Name")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Qty/P")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top text-right"},[_vm._v("Qty/O")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Trip")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("D Date")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("D Time")]),_vm._v(" "),_c('th',{staticClass:"border-bottom border-top"},[_vm._v("Status")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{},[_vm._v("#")]),_vm._v(" "),_c('th',{},[_vm._v("Pattern")]),_vm._v(" "),_c('th',{},[_vm._v("T No")]),_vm._v(" "),_c('th',{},[_vm._v("O Date")]),_vm._v(" "),_c('th',{},[_vm._v("O Time")]),_vm._v(" "),_c('th',{},[_vm._v("Category")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("Step")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"table-light"},[_c('tr',[_c('th',{},[_vm._v("#")]),_vm._v(" "),_c('th',{},[_vm._v("Pattern")]),_vm._v(" "),_c('th',{},[_vm._v("T No")]),_vm._v(" "),_c('th',{},[_vm._v("O Date")]),_vm._v(" "),_c('th',{},[_vm._v("O Time")]),_vm._v(" "),_c('th',{},[_vm._v("Category")]),_vm._v(" "),_c('th',{},[_vm._v("Step")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v("PerTruck")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/37.896be745215e6e720e5d.js